import React, {useCallback, useEffect, useState} from 'react';
import { useForm } from "react-hook-form";
import apiClient from "../../../utils/apiClient";
import FormSubmitButton from "../../forms/form-control/FormSubmitButton";
import FormInputDate from "../../forms/form-control/FormInputDate";
import {updateStateValue} from "../../../utils/stateHelpers";
import FormSelect from "../../forms/form-control/FormSelect";
import { useAuthenticate } from '../../../hooks/auth';

/**
 * Filter component
 * @returns {JSX.Element}
 * @constructor
 */
const ClientDailiesFilters = (prop) => {
    const {register, handleSubmit, errors, getValues} = useForm();
    const {filters, setFilters, setTableData} = prop;
    const [clients, setClients] = useState([]);
    const [rigs, setRigs] = useState([]);
    const { user } = useAuthenticate();
    const CLIENT_GROUP_ID = 5;

    const getRigs = useCallback(() => {
        // run only for clients
        if (user?.group_id === CLIENT_GROUP_ID)
        {
            let dateFrom = getValues('date_from');
            let dateTo = getValues('date_to');

            if (dateFrom.length === 10 && dateTo.length === 10) {
                apiClient
                    .post('getClientRigs', {
                            'date_from': dateFrom,
                            'date_to': dateTo
                        }
                    )
                    .then(response => {
                        setRigs(
                            response.data.map(
                                ({id, name}) => ({id: id, name: name})
                            )
                        );
                    });
            }
        }
    }, [getValues, user?.group_id]);

    // get list of active clients
    useEffect(() => {
        apiClient
            .get('getActiveClientsList')
            .then(response => {
                setClients(
                    response.data.activeClientsList.map(
                        ({id, client_name}) => ({id: id, name: client_name})
                    )
                );
            });

        // get list of rigs for client, will not work for admin
        getRigs();
    }, [getRigs]);

    const onSubmit = (data) => {
        updateStateValue(setFilters, 'isLoading', true);
        updateStateValue(setFilters, 'isSubmitted', true);

        apiClient
            .post('getClientDailies', data)
            .then(response => {
                if (Object.keys(response.data).length === 0) {
                    setTableData([]);
                    return;
                }
                setTableData(response.data);
            })
            .catch(function () {
                setTableData([]);
            }).then(function () {
            updateStateValue(setFilters, 'isLoading', false);
        });
    }

    return (
        <form
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row s-gy">
                {
                    (user?.group_id !== CLIENT_GROUP_ID) &&
                        <FormSelect
                            id="client_id"
                            label="Client"
                            className="col-xs-12 col-sm-6 col-md-3 col-lg-3"
                            options={clients}
                            register={register}
                        />
                }
                <FormInputDate
                    id="date_from"
                    label="Start Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.date_from}
                    register={register({required: "required"})}
                    onBlur={() => getRigs()}
                    errors={errors}
                />
                <FormInputDate
                    id="date_to"
                    label="End Date"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    value={filters.date_to}
                    register={register({required: "required"})}
                    onBlur={() => getRigs()}
                    errors={errors}
                />
                {
                    (user?.group_id === CLIENT_GROUP_ID) &&
                        <FormSelect
                            id="rig_id"
                            label="Rig"
                            className="col-xs-12 col-sm-6 col-md-3 col-lg-3"
                            options={rigs}
                            register={register}
                        />
                }
                <FormSubmitButton
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    label="Show"
                />
            </div>
        </form>
    );
}

export default ClientDailiesFilters;
